export enum FgStockStates {
    AllocatedForRepacking = 'Allocated For Repacking',
    AllocatedForReprocessing = 'Allocated For Reprocessing',
    AssignedForRepacking = 'Assigned For Repacking',
    PartiallyAssignedForRepacking = 'Partially Assigned For Repacking',
    PartiallyAssignedForReprocessing = 'Partially Assigned For Reprocessing',
    AssignedForReprocessing = 'Assigned For Reprocessing',
    Stock = 'Stock',
}